import {
  addDays,
  addHours,
  differenceInCalendarWeeks,
  eachDayOfInterval,
  endOfDay,
  endOfWeek,
  format,
  getDay,
  isSameWeek,
  max,
  parse,
  parseISO,
  startOfDay,
  startOfWeek,
  subYears,
} from 'date-fns';

export const parseDate = (date: string): Date =>
  parse(
    date,
    'yyyy-MM-dd',
    new Date(new Date().setMinutes(new Date().getMinutes() + 120)),
  );
export const parseDisplayDate = (date: string): Date =>
  parse(
    date,
    'd/M/yyyy',
    new Date(new Date().setMinutes(new Date().getMinutes() + 120)),
  );
export const parseDateTimeUtc = (date: string): Date => parseISO(date);
export const parseTime = (time: string, baseDate: Date): Date =>
  parse(time, 'HH:mm:ss', baseDate);
export const formatDateTime = (dateTime: Date): string =>
  format(dateTime, "yyyy-MM-dd'T'HH:mm:ss");
export const formatTime = (dateTime: Date): string => format(dateTime, 'HH:mm');
export const getMonday = (date: Date): Date =>
  startOfWeek(date, { weekStartsOn: 1 });
export const getSunday = (date: Date): Date =>
  endOfWeek(date, { weekStartsOn: 1 });
export const getDatesOfInterval = (start: Date, end: Date): Date[] =>
  eachDayOfInterval({ start, end });
export const beginningOfDay = (date: Date): Date => startOfDay(date);
export const endingOfDay = (date: Date): Date => endOfDay(date);
export const getDatePlusNumberDays = (date: Date, daysAdded: number): Date =>
  addDays(date, daysAdded);
export const maxDate = (firstDate: Date, secondDate: Date): Date =>
  max([firstDate, secondDate]);
export const calculateWeeksOffset = (
  firstDate: Date,
  secondDate: Date,
  weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6,
): number =>
  differenceInCalendarWeeks(firstDate, secondDate, {
    weekStartsOn: weekStartsOn,
  });
export const subtractYears = (date: Date, years: number): Date =>
  subYears(date, years);
export const formatDate = (date: Date): string => format(date, 'yyyy-MM-dd');
export const formatDateForDisplay = (date: Date): string =>
  format(date, 'd/M/yyyy');
export const addHoursToDate = (date: Date, hours: number) =>
  addHours(date, hours);
export const formatDateTimeAsFakeUTC = (dateTime: Date): string =>
  format(dateTime, "yyyy-MM-dd'T'HH:mm:ss.SSSS") + 'Z';
export const getNextWeekStartDate = (date: Date): Date =>
  getDatePlusNumberDays(getSunday(date), 1);
export const isNotInSameWeek = (firstDate: Date, secondDate: Date): boolean =>
  !isSameWeek(firstDate, secondDate);
export const getDayIndex = (date: Date): 0 | 1 | 2 | 3 | 4 | 5 | 6 =>
  getDay(date) as 0 | 1 | 2 | 3 | 4 | 5 | 6;
